import * as React from 'react'

import { Skeleton } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import LocationMultiselector from 'modules/locations/components/LocationMultiselector'
import type DefaultShiftForm from 'modules/shift_management/lib/forms/DefaultShiftForm'
import { useAllLocations } from 'modules/shift_management/lib/useSelectableLocations'
import TeamMultiselector from 'modules/teams/components/TeamMultiselector'

interface Props {
  form: DefaultShiftForm
}

const MultiSelector = ({ form }: Props) => {
  const teamsInForm = form.get('teams_ids_visibilities').value
  const locationsInForm = form.get('locations_ids_visibilities').value
  const [teamsIds, setTeamIds] = React.useState<string[]>(teamsInForm)
  const [locationsIds, setLocationIds] = React.useState<string[]>(locationsInForm)

  const isFormComplete =
    !!form.get('all_company').value ||
    !!form.get('locations_ids_visibilities').value.length ||
    !!form.get('teams_ids_visibilities').value.length

  const onSelectTeams = (ids: string[]) => {
    setTeamIds(ids)
    form.get('teams_ids_visibilities').set(ids)
  }

  const onSelectLocations = (ids: string[]) => {
    setLocationIds(ids)
    form.get('locations_ids_visibilities').set(ids)
  }

  const { loading, locations } = useAllLocations()

  return (
    <>
      <TeamMultiselector
        selectedTeamsIds={teamsIds}
        disabled={false}
        onSelectedTeamsChanged={(ids) => onSelectTeams(ids)}
        mandatory={!isFormComplete}
      />
      {loading ? (
        <Skeleton height="s40" />
      ) : (
        <LocationMultiselector
          selectedLocationsIds={locationsIds}
          disabled={false}
          onSelectedLocationsChanged={(ids) => onSelectLocations(ids)}
          mandatory={!isFormComplete}
          locations={locations}
        />
      )}
    </>
  )
}

export default observer(MultiSelector)
